import { render } from "./fiveFView.vue?vue&type=template&id=1e4c2985&scoped=true"
import script from "./fiveFView.vue?vue&type=script&lang=js"
export * from "./fiveFView.vue?vue&type=script&lang=js"

import "./fiveFView.vue?vue&type=style&index=0&id=1e4c2985&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e4c2985"]])

export default __exports__